const styles = () => ({
  root: {
    marginTop: 150,
  },
  container: {
    width: '50%',
    margin: 'auto',
  },
});

export default styles;
